import { useState, useEffect, useRef } from 'react'
import { hideLoadingBox, showLoadingBox, showMessageBox } from '../../../../../store/actions/system.actions'
import { errorHandler } from '../../../../../services/util/error.service'
import { parseToMysqlFormat } from '../../../../../services/util/date.service'
import * as CarregamentoHttp from '../../../../../services/api/https/deliveries/carregamento.http'
import { simularRoteirizacaoAutomatica } from '../../../../../services/api/https/deliveries/roteirizacao-automatica.http'

export function getVehicleColor(idx) {
  const hue = (idx * 137.508) % 360
  return 'hsl(' + Math.round(hue) + ', 65%, 42%)'
}

export function useRoteirizacaoAutomaticaHook({ history, selectedTp, dispatch }) {
  const { vehicles = [], entregas: initialEntregas = [], dataPrevista: initialDate } = history.location.state || {}
  const [entregas, setEntregas] = useState(initialEntregas)

  const [dataPrevista, setDataPrevista] = useState(initialDate || new Date())
  const [selectedVehicleIds, setSelectedVehicleIds] = useState([])
  const [selectedStepIds, setSelectedStepIds] = useState([])
  const [selecionarTodas, setSelecionarTodas] = useState(false)
  const [simulationResult, setSimulationResult] = useState(null)
  const [simulationOutdated, setSimulationOutdated] = useState(false)
  const [isSimulating, setIsSimulating] = useState(false)
  const [isSaving, setIsSaving] = useState(false)

  const markOutdated = function() {
    if (simulationResult) setSimulationOutdated(true)
  }

  const prevTpRef = useRef(selectedTp)
  useEffect(function() {
    if (prevTpRef.current !== selectedTp) {
      history.goBack()
    }
  })

  const handleSetDataPrevista = function(val) {
    setDataPrevista(val)
    markOutdated()
  }

  const handleSetSelectedVehicleIds = function(val) {
    setSelectedVehicleIds(val)
    markOutdated()
  }

  const onSimular = () => {
    if (!dataPrevista) {
      dispatch(showMessageBox(null, 'Informe a data prevista de entrega'))
      return
    }
    if (!selectedTp) {
      dispatch(showMessageBox(null, 'Nenhum TP selecionado'))
      return
    }
    if (selectedVehicleIds.length === 0) {
      dispatch(showMessageBox(null, 'Selecione ao menos um veículo'))
      return
    }
    if (selectedStepIds.length === 0) {
      dispatch(showMessageBox(null, 'Selecione ao menos uma entrega'))
      return
    }

    setIsSimulating(true)
    dispatch(showLoadingBox('Calculando rotas otimizadas...'))

    simularRoteirizacaoAutomatica({
      tp_id: selectedTp,
      vehicle_ids: selectedVehicleIds,
      step_ids: selectedStepIds,
      expected_date: parseToMysqlFormat(dataPrevista),
    })
      .then(function(result) {
        setSimulationResult(result)
        setSimulationOutdated(false)
      })
      .catch(error => {
        var msg = typeof error === 'string'
          ? error
          : (!error.response
            ? 'Não foi possível conectar ao servidor. Verifique sua conexão com a internet e tente novamente.'
            : errorHandler(error))
        dispatch(showMessageBox(null, msg))
      })
      .finally(() => {
        setIsSimulating(false)
        dispatch(hideLoadingBox())
      })
  }

  const onSalvar = () => {
    if (!simulationResult || simulationResult.routes.length === 0) {
      dispatch(showMessageBox(null, 'Execute a simulação antes de salvar'))
      return
    }

    setIsSaving(true)
    dispatch(showLoadingBox('Salvando carregamento...'))

    const carregamentos = simulationResult.routes.map(r => {
      const vehicle = vehicles.find(v => v.id === r.vehicle_id)
      const delivery_steps = r.stops.flatMap(function(stop, i) {
        return stop.step_ids.map(function(step_id) {
          return { step_id: step_id, delivery_sequence: i + 1 }
        })
      })
      return {
        vehicle_id: r.vehicle_id,
        driver_id: vehicle ? vehicle.default_driver_id : null,
        expected_date: parseToMysqlFormat(dataPrevista),
        delivery_step_ids: r.step_ids,
        delivery_steps: delivery_steps,
      }
    })

    CarregamentoHttp.saveCarregamento(selectedTp, carregamentos)
      .then(() => {
        dispatch(showMessageBox('Carregamento salvo com sucesso', null))
        history.goBack()
      })
      .catch(error => dispatch(showMessageBox(null, errorHandler(error))))
      .finally(() => {
        setIsSaving(false)
        dispatch(hideLoadingBox())
      })
  }

  const onToggleEntrega = entrega => {
    setSelectedStepIds(prev => {
      if (prev.includes(entrega.step_id)) return prev.filter(id => id !== entrega.step_id)
      return [...prev, entrega.step_id]
    })
    setSelecionarTodas(false)
    markOutdated()
  }

  const onSelecionarTodas = (value, visibleList) => {
    setSelecionarTodas(value)
    setSelectedStepIds(value ? (visibleList || entregas).map(e => e.step_id) : [])
    markOutdated()
  }

  const updateEntregaCoords = function(clientId, latitude, longitude) {
    setEntregas(function(prev) {
      return prev.map(function(e) {
        if (e.client_id !== clientId) return e
        return Object.assign({}, e, { latitude: latitude, longitude: longitude })
      })
    })
  }

  const vehicleOptions = vehicles.map(v => ({ label: v.vehicle_badge, value: v.id }))

  return {
    vehicles,
    entregas,
    dataPrevista,
    setDataPrevista: handleSetDataPrevista,
    selectedVehicleIds,
    setSelectedVehicleIds: handleSetSelectedVehicleIds,
    selectedStepIds,
    selecionarTodas,
    simulationResult,
    simulationOutdated,
    markSimulationOutdated: markOutdated,
    updateEntregaCoords,
    isSimulating,
    isSaving,
    onSimular,
    onSalvar,
    onToggleEntrega,
    onSelecionarTodas,
    vehicleOptions,
  }
}
